import {
  GetMovieDetailParams,
  MovieDetailItem,
  MovieImagesResponse,
  PopularParams,
  SearchParams,
  TmdbResponse,
  MovieCreditsResponse,
  MovieWatchProvidersResponse,
} from "../utils/types";

export const getPopularMovies = async (
  params: PopularParams,
): Promise<TmdbResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/popular?api_key=${process.env.REACT_APP_RAPID_API_KEY}&page=${params.page}&region=IN`,
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: TmdbResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movies", e);
  }
};

export const getSearchedMovies = async ({
  query,
  page,
}: SearchParams): Promise<TmdbResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}search/movie?api_key=${process.env.REACT_APP_RAPID_API_KEY}&page=${page}&region=IN&query=${query}`,
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: TmdbResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movies", e);
  }
};

export const getMovieDetail = async ({
  id,
}: GetMovieDetailParams): Promise<MovieDetailItem | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/${id}?api_key=${process.env.REACT_APP_RAPID_API_KEY}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: MovieDetailItem = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movies", e);
  }
};

export const getMovieTrailer = async ({
  id,
}: GetMovieDetailParams): Promise<string | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/${id}/videos?api_key=${process.env.REACT_APP_RAPID_API_KEY}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json = await res.json();
    const trailerArray = json.results.filter(
      (item: any) =>
        item.site.toLowerCase() === "youtube" &&
        item.type.toLowerCase() === "trailer" &&
        item.name.toLowerCase().includes("trailer"),
    );
    if (trailerArray.length > 0) {
      return `https://www.youtube.com/watch?v=${trailerArray[0].key}`;
    }
  } catch (e) {
    console.warn("Error in get movies trailer", e);
  }
};

export const getTopRatedMovies = async (
  params: PopularParams,
): Promise<TmdbResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/top_rated?api_key=${process.env.REACT_APP_RAPID_API_KEY}&page=${params.page}&region=IN`,
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: TmdbResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movies", e);
  }
};

export const getUpcomingMovies = async (
  params: PopularParams,
): Promise<TmdbResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/upcoming?api_key=${process.env.REACT_APP_RAPID_API_KEY}&page=${params.page}&region=IN`,
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: TmdbResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movies", e);
  }
};

export const getMovieImages = async ({
  id,
}: GetMovieDetailParams): Promise<MovieImagesResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/${id}/images?api_key=${process.env.REACT_APP_RAPID_API_KEY}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: MovieImagesResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movie images", e);
  }
};

export const getRecommendedMovies = async ({
  id,
}: GetMovieDetailParams): Promise<TmdbResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/${id}/recommendations?api_key=${process.env.REACT_APP_RAPID_API_KEY}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: TmdbResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get recommended movies", e);
  }
};

export const getMovieCast = async ({
  id,
}: GetMovieDetailParams): Promise<MovieCreditsResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/${id}/credits?api_key=${process.env.REACT_APP_RAPID_API_KEY}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: MovieCreditsResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movie cast", e);
  }
};

export const getMovieWatchProviders = async ({
  id,
}: GetMovieDetailParams): Promise<MovieWatchProvidersResponse | undefined> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAPID_BASE_URL}movie/${id}/watch/providers?api_key=${process.env.REACT_APP_RAPID_API_KEY}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const json: MovieWatchProvidersResponse = await res.json();
    return json;
  } catch (e) {
    console.warn("Error in get movie watch providers", e);
  }
};

